import { Loader2 } from "lucide-react";

/**
 * Full-screen loading state for in-flight delete/save mutations (copy of
 * lcaCompany's `LoadingOverlay`). `z-[60]` so it paints above the `z-50`
 * Sheet used by the Register/Edit/Details drawers.
 */
const LoadingOverlay = () => (
  <div
    className="tw-fixed tw-inset-0 tw-z-[60] tw-flex tw-items-center tw-justify-center tw-bg-white/75 tw-backdrop-blur-[1px]"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-primary/20 tw-bg-white tw-px-8 tw-py-5 tw-shadow-md">
      <Loader2 className="tw-h-8 tw-w-8 tw-animate-spin tw-text-primary" />
      <p className="tw-text-sm tw-font-medium tw-text-primary">Loading...</p>
    </div>
  </div>
);

export default LoadingOverlay;
